import angular from 'angular';

import component from './preferences-guidelines.component';

const PreferencesGuidelines = angular
    .module('control-room.app-settings.components.preferences-details.components.preferences-guidelines', [])
    .component('crPreferencesGuidelines', component);

export default PreferencesGuidelines;
